import { render, staticRenderFns } from "./MenuTop.vue?vue&type=template&id=86431e92&scoped=true"
import script from "./MenuTop.vue?vue&type=script&lang=ts"
export * from "./MenuTop.vue?vue&type=script&lang=ts"
import style0 from "./MenuTop.vue?vue&type=style&index=0&id=86431e92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86431e92",
  null
  
)

export default component.exports